module.exports = __webpack_public_path__ + "static/media/proj16_img1.bca13886.jpg";